import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextInputField, SelectField } from '@bucketplace/commerce-admin-ui';
import 'use-context-selector';
import { jsx } from '@emotion/react';
import { useLinkContext } from '../../contexts/internal/LinkContext.js';
import '../../contexts/internal/StickyContext.js';
import '../../contexts/internal/EditorContext.js';
import '../../components/Canvas/Canvas.style.js';
import '../../components/Canvas/PreviewModeContainer.js';
import '../../components/Duration/DurationInput.js';
import '../../components/FieldItem.js';
import '../../components/FormGroup/FormGroup.js';
import { LogDataFormGroup } from '../../components/FormGroup/LogDataFormGroup.js';
import '../../components/Header/index.js';
import '../../components/Input/ColorPickerField/index.js';
import '../../components/Input/URLInput.js';
import '../../components/Inspector/Inspector.js';
import '../../components/TreeList/TreeList.style.js';
import '@react-icons/all-files/hi/HiChevronDown';
import '@react-icons/all-files/hi/HiChevronRight';
import '@react-icons/all-files/ri/RiCloseCircleFill';
import '@react-icons/all-files/ri/RiDeleteBinLine';
import '@react-icons/all-files/ri/RiFileCopyLine';
import '@react-icons/all-files/ri/RiShapeLine';
import 'qs';
import 'query-string';
import '@react-icons/all-files/md/MdLens';
import 'lodash-es';
import '@bucketplace/ui';
import '@bucketplace/bucket-log';
import 'react-dom';
import '../../components/Tooltip/Tooltip.js';
import '../../components/Toolbar/Toolbar.style.js';
import '../../components/TreeList/Draggable.js';
import '../../components/EditorPlaceholder/EditorPlaceholder.js';
import { FormContent } from '../../components/FormContent.js';
import { InspectorFormProvider } from '../../components/InspectorFormProvider.js';

var _excluded = ["children"];
var OPEN_OPTIONS = [{
  value: 'sameTab',
  text: '현재 창'
}, {
  value: 'newTab',
  text: '새 창'
}, {
  value: 'anchor',
  text: '앵커'
}];
function LinkInspector(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  return jsx(InspectorFormProvider, {
    value: value,
    onChange: onChange
  }, jsx(LinkInspectorFields, {
    value: value
  }));
}
function LinkInspectorFields(_ref2) {
  var _value$props;
  var customNames = _ref2.names,
    customLabels = _ref2.labels,
    value = _ref2.value;
  var _useFormContext = useFormContext(),
    setValue = _useFormContext.setValue;
  var _ref3 = (_value$props = value === null || value === void 0 ? void 0 : value.props) !== null && _value$props !== void 0 ? _value$props : {},
    style = _ref3.style;
  var names = _objectSpread2(_objectSpread2({}, {
    to: 'to',
    openOption: 'openOption',
    logData: 'logData'
  }), customNames);
  var labels = _objectSpread2(_objectSpread2({}, {
    to: 'URL',
    openOption: '이동 방식',
    logData: '로그'
  }), customLabels);
  useEffect(function () {
    setValue('style', style);
  }, [style, setValue]);
  return jsx(React__default.Fragment, null, jsx(FormContent, {
    header: labels.to,
    required: true,
    direction: "VERTICAL"
  }, jsx(TextInputField, {
    name: names.to,
    width: "100%",
    rules: {
      required: true,
      validate: function validate(value) {
        return value.trim() !== '';
      }
    }
  })), jsx(FormContent, {
    header: labels.openOption
  }, jsx(SelectField, {
    name: names.openOption,
    width: "100%",
    options: OPEN_OPTIONS
  })), jsx(LogDataInput, {
    value: value
  }));
}
var LogDataInput = /*#__PURE__*/React__default.memo(function (_ref4) {
  var value = _ref4.value;
  var _useLinkContext = useLinkContext(),
    setLogData = _useLinkContext.setLogData;
  var _ref5 = value !== null && value !== void 0 ? value : {};
    _ref5.children;
    var others = _objectWithoutProperties(_ref5, _excluded);
  return jsx(LogDataFormGroup, _extends({
    nodeKey: value === null || value === void 0 ? void 0 : value.key
  }, setLogData === null || setLogData === void 0 ? void 0 : setLogData(others)));
});

export { LinkInspector, LinkInspectorFields };
//# sourceMappingURL=LinkInspector.js.map
